$(document).ready(function(){
  
  
    $('.testimonial_col').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  adaptiveHeight: false,
  arrows:true,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 21C9 15.8661 0.999999 13.2991 0.999999 10.7321C0.999999 8.16517 9 6.45382 9 0.464266" stroke="#F47044" stroke-width="2"/></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0C1 5.13393 9 7.7009 9 10.2679C9 12.8348 1 14.5462 1 20.5357" stroke="#F47044" stroke-width="2"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
         arrows:false,
        slidesToScroll: 1,
         adaptiveHeight: true
      }
    }
  ]
  
});

$('#home-blog').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  adaptiveHeight: false,
 arrows:true,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 21C9 15.8661 0.999999 13.2991 0.999999 10.7321C0.999999 8.16517 9 6.45382 9 0.464266" stroke="#F47044" stroke-width="2"/></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0C1 5.13393 9 7.7009 9 10.2679C9 12.8348 1 14.5462 1 20.5357" stroke="#F47044" stroke-width="2"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        infinite: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
          centerMode: true,
        centerPadding: '30px'
      }
    }
  ]
  
});

// ----------------------home page product list
  $('.top-tab .tab-link').click(function(){
    $('.top-product-list .product-listing .js-carousel.slick-initialized').slick("unslick");
 $('.top-product-list .product-listing .slider-main.slick-initialized').slick("unslick");
    $('.top-product-list .product-listing .slider-nav.slick-initialized').slick("unslick");
    $('.top-tab .tab-link').removeClass('active');
    $(this).addClass('active');
    var tab_id=$(this).data('tab');
    $('.top-product-list .product-listing').removeClass('product-active');
    $('.top-product-list .product-listing[data-tab-product='+tab_id+']').addClass('product-active');
    $('.top-product-list .product-listing .js-carousel').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button class="prev-arrow"><svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 21C9 15.8661 0.999999 13.2991 0.999999 10.7321C0.999999 8.16517 9 6.45382 9 0.464266" stroke="white" stroke-width="2"/></svg></button>',
      nextArrow: '<button class="next-arrow"><svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0C1 5.13393 9 7.7009 9 10.2679C9 12.8348 1 14.5462 1 20.5357" stroke="white" stroke-width="2"/></svg></button>'
    });

     $('.slider-main').slick({
        slidesToShow: 1,
        arrows: false,
        infinite:true,
        asNavFor: '.slider-nav',
        focusOnSelect: true,
          responsive: [
            {
              breakpoint: 576,
              settings: {
                arrows:true,
                prevArrow:'<button class="prev-img"><svg width="24" height="24" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.77689 0.872L7.77689 2.536L1.02489 5.064L1.02489 4.136L7.77689 6.664L7.77689 8.328L0.400893 5.464L0.400893 3.736L7.77689 0.872Z" fill="white"/></svg></button>',
          		nextArrow:'<button class="next-img"><svg width="24" height="24" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.905234 8.128V6.464L7.65723 3.936V4.864L0.905234 2.336V0.672L8.28123 3.536V5.264L0.905234 8.128Z" fill="white"/></svg></button>'
              }
            },
          ]
      });
      
      $('.slider-nav').slick({
        slidesToShow: 4,
         slidesToScroll: 1,
        asNavFor: '.slider-main',
        infinite:true,
        vertical: true,
        verticalSwiping: true,
        focusOnSelect: true,
        arrows:true,
        prevArrow: '<div class="slick-arrow slick-prev"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_224_" d="M325.606,229.393l-150.004-150C172.79,76.58,168.974,75,164.996,75c-3.979,0-7.794,1.581-10.607,4.394 l-149.996,150c-5.858,5.858-5.858,15.355,0,21.213c5.857,5.857,15.355,5.858,21.213,0l139.39-139.393l139.397,139.393 C307.322,253.536,311.161,255,315,255c3.839,0,7.678-1.464,10.607-4.394C331.464,244.748,331.464,235.251,325.606,229.393z"/></svg></div>',
        nextArrow: '<div class="slick-arrow slick-next"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"/></svg></div>',
      }); 
  });


  $('.top-product-list .product-listing .js-carousel').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="prev-arrow"><svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 21C9 15.8661 0.999999 13.2991 0.999999 10.7321C0.999999 8.16517 9 6.45382 9 0.464266" stroke="white" stroke-width="2"/></svg></button>',
    nextArrow: '<button class="next-arrow"><svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0C1 5.13393 9 7.7009 9 10.2679C9 12.8348 1 14.5462 1 20.5357" stroke="white" stroke-width="2"/></svg></button>'
  });
//----------------------home page product thumbnail
 $('.slider-main').slick({
        slidesToShow: 1,
        arrows: false,
        infinite:true,
        asNavFor: '.slider-nav',
        focusOnSelect: true
      });
      
      $('.slider-nav').slick({
        slidesToShow: 4,
         slidesToScroll: 1,
        asNavFor: '.slider-main',
        infinite:true,
        vertical: true,
        verticalSwiping: true,
        focusOnSelect: true,
        arrows:true,
        prevArrow: '<div class="slick-arrow slick-prev"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_224_" d="M325.606,229.393l-150.004-150C172.79,76.58,168.974,75,164.996,75c-3.979,0-7.794,1.581-10.607,4.394 l-149.996,150c-5.858,5.858-5.858,15.355,0,21.213c5.857,5.857,15.355,5.858,21.213,0l139.39-139.393l139.397,139.393 C307.322,253.536,311.161,255,315,255c3.839,0,7.678-1.464,10.607-4.394C331.464,244.748,331.464,235.251,325.606,229.393z"/></svg></div>',
        nextArrow: '<div class="slick-arrow slick-next"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"/></svg></div>',
      }); 

$('.great_for_col').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  adaptiveHeight: false,
  arrows:false,
  prevArrow: '<button class="slide-arrow prev-arrow"><svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 21C9 15.8661 0.999999 13.2991 0.999999 10.7321C0.999999 8.16517 9 6.45382 9 0.464266" stroke="#F47044" stroke-width="2"/></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow"><svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0C1 5.13393 9 7.7009 9 10.2679C9 12.8348 1 14.5462 1 20.5357" stroke="#F47044" stroke-width="2"/></svg></button>',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
           dots: true
      }
    },
      {
      breakpoint: 576,
      settings: {
         slidesToShow: 1,
         centerMode: true,
        autoplay: true,
        autoplaySpeed: 2000,
        centerPadding: '30px',
           dots: true
      }
    }
    
  ]
  
});
  

});